import React,{useState,useEffect} from 'react';
import { BrowserRouter as Router, Link, Route, Routes } from 'react-router-dom';
import User from './User';
import Admin from './Admin';
import FormList from './FormList';
import './App.css';
import Login from './Login';
import { getForms } from './api';
import NotFound from './NotFound';
import Patient from './patient';
const Home = () => {
  return (
    <div>
      <nav>
        <ul>
        <li>
            <Link to="/Admin">Admin</Link>
          </li>
          <li>
            <Link to="/User">User</Link>
          </li>
          <li>
            <Link to="/FormList">FormList</Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

const App = () => {
  const [nonConsentforms, setNonConsentForms] = useState([]
  );
  const [consentforms, setConsentForms] = useState([]
    );
  const [signaturevalue, setSignatureValue] = useState('');

 

  useEffect( () => {
    // Retrieve saved forms from local storage
  // localStorage.removeItem('savedForms');
  fetchData();
   
  }, []);
  async function fetchData(){
    try{
    const res= await getForms();
    if (res) {
      // Separate forms into consent and non-consent arrays
      const consentForms = res.filter(form => form.consent ==1);
      const nonConsentForms = res.filter(form => form.consent != 1);
      //setForms(res);
      setConsentForms(consentForms);
      setNonConsentForms(nonConsentForms);
    }
  } catch (error) {
    console.error('Error fetching forms:', error);
  }
  }

  return (
    <Router>
      <Routes>
      <Route path="/" element={<Patient />} />
        <Route path="/:id" element={<Login />} />
        <Route path="/User/:id" element={<User/>} />
        <Route path="/Admin" element={<Admin consentforms={consentforms} setConsentForms={setConsentForms}  nonConsentforms={nonConsentforms} setNonConsentForms={setNonConsentForms} fetchFormData={fetchData } />} />
        <Route path="/FormList" element={<FormList  consentforms={consentforms} setConsentForms={setConsentForms}  nonConsentforms={nonConsentforms} setNonConsentForms={setNonConsentForms} />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default App;


